/**
 * IMAGE_OPTION_HOTSPOT 运行时布局解析
 */

import { rpxToPx } from '@/utils'
import { resolveUploadUrl } from '@/utils/uploadBase'

export const LAYOUT_TYPE_IMAGE_OPTION = 'IMAGE_OPTION_HOTSPOT'

export function parseImageOptionLayoutConfig(raw) {
  if (!raw) return null
  let obj = raw
  if (typeof raw === 'string') {
    try {
      obj = JSON.parse(raw)
    } catch (e) {
      return null
    }
  }
  if (!obj || typeof obj !== 'object') return null
  if (obj.layoutType && String(obj.layoutType).toUpperCase() !== LAYOUT_TYPE_IMAGE_OPTION) {
    if (!Array.isArray(obj.options)) return null
  }
  return {
    layoutType: LAYOUT_TYPE_IMAGE_OPTION,
    options: Array.isArray(obj.options) ? obj.options : [],
    nextButton: obj.nextButton && typeof obj.nextButton === 'object' ? obj.nextButton : null,
    imageOptionSubmitMode:
      obj.imageOptionSubmitMode != null && String(obj.imageOptionSubmitMode).trim() !== ''
        ? String(obj.imageOptionSubmitMode).trim().toUpperCase()
        : null
  }
}

export function imageOptionHotspotStyle(box, rpxPx) {
  if (!box || typeof box !== 'object' || typeof rpxPx !== 'function') return {}
  const left = Number(box.left) || 0
  const top = Number(box.top) || 0
  const w = Number(box.sizeWidth) || 20
  const h = Number(box.sizeHeight) || 8
  return {
    position: 'absolute',
    left: rpxPx((left / 100) * 750),
    top: rpxPx((top / 100) * 1334),
    width: rpxPx((w / 100) * 750),
    height: rpxPx((h / 100) * 1334),
    transform: 'translate(-50%, -50%)',
    boxSizing: 'border-box',
    overflow: 'hidden'
  }
}

export function normalizeQuizImageUrl(url) {
  return resolveUploadUrl(url)
}
